import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildZP_C_DOVOD = () => {
  return `${urls.ZP_C_DOVOD}`;
};

export const getZP_C_DOVOD = async () => {
  const url = buildZP_C_DOVOD();
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};
